import { Box } from "@mui/material";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import FundSelect from "../common/FundSelect";
import WidgetCardWrapper from "./WidgetCardWrapper";
import WidgetContent from "./WidgetContent";
import WidgetHeader from "./WidgetHeader";
import { usePortfolioWidgetData } from "./widgetHooks";

interface Props {
  widgetSettings: PortalWidget;
}

const PortfolioWidget = ({ widgetSettings }: Props) => {
  const gridApiRef = useGridApiRef();
  const {
    parameters,
    report,
    fetchError,
    isRunningReport,
    noDataText,
    fundId,
    setFundId,
    searchValue,
    setSearchValue,
    filteredRows,
  } = usePortfolioWidgetData(widgetSettings);

  return (
    <WidgetCardWrapper withFullScreenButton>
      <WidgetHeader name={widgetSettings.name}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <FundSelect
            funds={parameters?.funds ?? []}
            selectedFundId={fundId ?? ""}
            onChange={setFundId}
            disabled={!parameters?.funds.length || isRunningReport}
          />

          <SearchField
            initialValue={searchValue}
            onSearch={setSearchValue}
            disabled={!report?.rows.length || isRunningReport}
            debounceTimeMs={300}
          />
        </Box>
      </WidgetHeader>
      <WidgetContent
        report={report}
        rows={filteredRows}
        noDataText={noDataText}
        footnote={widgetSettings.footnote}
        loading={isRunningReport}
        fetchError={fetchError}
        gridApiRef={gridApiRef}
      />
    </WidgetCardWrapper>
  );
};

export default PortfolioWidget;
